"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TASKTYPE = void 0;
var TASKTYPE;
(function (TASKTYPE) {
    TASKTYPE["AR_LOADING"] = "ar_loading";
    TASKTYPE["ENVIRONMENT_MAP_LOADING"] = "environment_map_loading";
    TASKTYPE["SESSION_CUSTOMIZATION"] = "session_customization";
    TASKTYPE["SESSION_CREATION"] = "session_creation";
    TASKTYPE["SESSION_INITIAL_OUTPUTS_LOADED"] = "session_initial_outputs_loaded";
    TASKTYPE["SESSION_OUTPUTS_UPDATE"] = "session_outputs_update";
    TASKTYPE["VIEWER_CREATION"] = "viewer_creation";
    TASKTYPE["EXPORT_REQUEST"] = "export_request";
})(TASKTYPE = exports.TASKTYPE || (exports.TASKTYPE = {}));
//# sourceMappingURL=ITaskEvent.js.map